	import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import preloadScript from '../../../../src/preloadScript'
import OTSession from '../../../../src/OTSession'
import OTStreams from '../../../../src/OTStreams'
// import {
// 	Modal,
// 	ModalHeader,
// 	ModalTitle,
// 	ModalClose,
// 	ModalBody,
// 	ModalFooter,

// } from 'react-modal-bootstrap';
import ConnectionStatus from './connectionStatus';
import Publisher from './publisher';
import Subscriber from './subscriber';
import config from '../config';

class VideoCall extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: null,
			connected: false
		};
		this.onError = this.onError.bind(this);

		this.sessionEvents = {
			sessionConnected: () => {
				this.setState({ connected: true });
			},
			sessionDisconnected: () => {
				this.setState({ connected: false });
			}
		};
	}

	componentWillMount() {
		OT.registerScreenSharingExtension('chrome', config.CHROME_EXTENSION_ID, 2);
	}

	onError(err) {
		this.setState({ error: `Failed to connect: ${err.message}` });
	}
	disConnectCall() {
		this.props.disConnectCall(event)
	}
	gotoBack() {
		var x = document.getElementsByClassName("videoModal")[0].className;
		if (x == 'videoModal') {
			document.getElementsByClassName("videoModal")[0].className = "videoModal videoModalSmall";
		} else {
			document.getElementsByClassName("videoModal")[0].className = "videoModal";
		}
	}
	render() {
		return (
			<div className="videoModal" >
				{/* <Modal openModal={this.props.openVideoRoom} >
					<ModalHeader>

						<Link onClick={this.gotoBack}><img src={require('../../../images/images/left-arrow.svg')} /></Link>
						<ModalClose onClick={this.props.hideSigninModal} />
					</ModalHeader>
					<ModalBody> */}
						<div className='videobox'>
							<OTSession
								apiKey={this.props.apiKey}
								sessionId={this.props.sessionId}
								token={this.props.token}
								eventHandlers={this.sessionEvents}
								onError={this.onError}
							>
								{this.state.error ? <div>{this.state.error}</div> : null}
								<ConnectionStatus connected={this.state.connected} />
								<Publisher disConnectCall={this.props.disConnectCall} />
								<OTStreams>
									<Subscriber />
								</OTStreams>
							</OTSession>
						</div>
					{/* </ModalBody>
					<ModalFooter>
					</ModalFooter>
				</Modal > */}
			</div>



		);
	}
}

export default preloadScript(VideoCall);
